import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heroImages = [
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e88ecc525f3c4c053f9e72f9316900c5.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/875a37e04317ef8f5de8d20f57a4bbab.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/1cc2f38608ad90ecacb113470a02dec9.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/b84ad7ad43a67fee66e5199355ebb851.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/6d01f960d99fae17e7aeaefd2bf2f4ea.png'
  ];

  // Auto-rotate images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  const handleViewProducts = () => {
    navigate('/produtos');
  };

  const handleContact = () => {
    navigate('/contato');
  };

  const scrollToProducts = () => {
    const productsSection = document.querySelector('[data-product-shop]');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Image Carousel */}
      <div className="absolute inset-0">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div
              className="w-full h-full bg-cover bg-center bg-no-repeat"
              style={{
                backgroundImage: `url('${image}')`
              }}
            />
          </div>
        ))}
      </div>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-black/30"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-bold mb-6 leading-tight drop-shadow-2xl text-white">
            Soluções em
            <span className="block text-white">Food Service</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-white max-w-3xl mx-auto leading-relaxed drop-shadow-lg shadow-lg">
            Há mais de 20 anos oferecendo produtos de qualidade em alimentação. 
            Sua cozinha profissional merece o melhor.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="outline"
              size="lg" 
              className="shadow-xl backdrop-blur-sm"
              style={{ 
                borderColor: '#ffffff', 
                color: '#ffffff',
                backgroundColor: 'rgba(0, 0, 0, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
                e.currentTarget.style.color = 'black';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
                e.currentTarget.style.color = '#ffffff';
              }}
              onClick={handleViewProducts}
            >
              Conheça Nossos Produtos
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="shadow-xl backdrop-blur-sm"
              style={{ 
                borderColor: '#ffffff', 
                color: '#ffffff',
                backgroundColor: 'rgba(0, 0, 0, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
                e.currentTarget.style.color = 'black';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
                e.currentTarget.style.color = '#ffffff';
              }}
              onClick={handleContact}
            >
              <i className="ri-phone-line mr-2"></i>
              Entre em Contato
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-black/30 backdrop-blur-sm rounded-xl p-6 shadow-xl">
              <div className="text-3xl font-bold text-white mb-2">+20</div>
              <div className="text-white">Anos de Experiência</div>
            </div>
            <div className="bg-black/30 backdrop-blur-sm rounded-xl p-6 shadow-xl">
              <div className="text-3xl font-bold text-white mb-2">+500</div>
              <div className="text-white">Clientes Satisfeitos</div>
            </div>
            <div className="bg-black/30 backdrop-blur-sm rounded-xl p-6 shadow-xl">
              <div className="text-3xl font-bold text-white mb-2">+100</div>
              <div className="text-white">Produtos Disponíveis</div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Indicators */}
      <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 z-20">
        <div className="flex space-x-2">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentImageIndex 
                  ? 'bg-white scale-125' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
            />
          ))}
        </div>
      </div>
      
      <div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer"
        onClick={scrollToProducts}
      >
        <i className="ri-arrow-down-line text-white text-2xl drop-shadow-lg"></i>
      </div>
    </section>
  );
}
